import React from 'react';
import { Row, Col } from 'react-bootstrap';

import InfoRow from 'components/common/InfoRow';

const POAddressViewMode = ({ purchaseOrderAddress }) => {
  return (
    <Row>
      <Col md={3}>
        <InfoRow
          className="mb-3"
          label="Email"
          value={purchaseOrderAddress?.email}
        />

        <InfoRow
          className="mb-3"
          label="City"
          value={purchaseOrderAddress?.city}
        />

        <InfoRow
          className="mb-3"
          label="Authorised Person"
          value={purchaseOrderAddress?.name}
        />
      </Col>

      <Col md={3}>
        <InfoRow
          className="mb-3"
          label="Phone"
          value={purchaseOrderAddress?.phone}
        />

        <InfoRow
          className="mb-3"
          label="State"
          value={purchaseOrderAddress?.state}
        />
      </Col>

      <Col md={3}>
        <InfoRow
          className="mb-3"
          label="Address Line 1"
          value={purchaseOrderAddress?.address_line_1}
        />

        <InfoRow
          className="mb-3"
          label="Country"
          value={purchaseOrderAddress?.country}
        />
      </Col>

      <Col md={3}>
        <InfoRow
          className="mb-3"
          label="Address Line 2"
          value={purchaseOrderAddress?.address_line_2}
        />

        <InfoRow
          className="mb-3"
          label="Pincode"
          value={purchaseOrderAddress?.pincode}
        />
      </Col>
    </Row>
  );
};

export default POAddressViewMode;
